import React, { useEffect, useState } from "react";
import { ReactComponent as CallIcon } from "./../../assets/images/icons/Google SVGs/call.svg";
import { ReactComponent as LocationOnIcon } from "./../../assets/images/icons/Google SVGs/location_on.svg";
import { ReactComponent as ChatIcon } from "./../../assets/images/icons/Google SVGs/chat.svg";
import { ReactComponent as StethoscopeIcon } from "./../../assets/images/icons/Google SVGs/stethoscope.svg";
import { ReactComponent as DeleteIcon } from "./../../assets/images/icons/Google SVGs/delete.svg";
import { ReactComponent as AvgPaceIcon } from "./../../assets/images/icons/Google SVGs/avg_pace.svg";
import { ReactComponent as EnhancedEncryptionIcon } from "./../../assets/images/icons/Google SVGs/enhanced_encryption.svg";
import { ReactComponent as ChevronDownIcon } from "./../../assets/images/icons/Google SVGs/chevron_down.svg";
import { ReactComponent as ScheduleIcon } from "./../../assets/images/icons/Google SVGs/schedule.svg";
import { ReactComponent as DiversityIcon } from "./../../assets/images/icons/Google SVGs/diversity_4.svg";
import { ReactComponent as HomeHealthIcon } from "./../../assets/images/icons/Google SVGs/home_health.svg";
import { ReactComponent as VideoIcon } from "./../../assets/images/icons/Google SVGs/videocam.svg";
import PersianTimePicker from "../DateTimePicker/PersianTimePicker";

const ShiftFormCard = ({
  formId,
  formData,
  depPlace,
  updateForm,
  removeForm,
}) => {
  const [startTime, setStartTime] = useState();
  const [EndTime, setEndTime] = useState();
  const [customSession, setCustomSession] = useState(false);
  const [departmentPlaces, setDepartmentPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState("");
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [workOnHoliDay, setWorkOnHoliDay] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e;
    updateForm({ ...formData, [name]: value });
  };

  const handleStartTimeChange = (e) => {
    setStartTime(e);
    updateForm({ ...formData, start: e });
  };

  const handleEndTimeChange = (e) => {
    setEndTime(e);
    updateForm({ ...formData, end: e });
  };

  const handlePlaceChange = (e) => {
    setSelectedPlace(e);
    updateForm({ ...formData, place_id: e });
  };

  const handleDepartmentChange = (e) => {
    setSelectedDepartment(e);
    updateForm({ ...formData, department_id: e });
  };

  const handleInPersonTypeChange = (e) => {
    updateForm({ ...formData, has_in_person: e });
  };

  const handleTextTypeChange = (e) => {
    updateForm({ ...formData, has_text: e });
  };

  const handleVoiceTypeChange = (e) => {
    updateForm({ ...formData, has_voice_call: e });
  };

  const handleVideoTypeChange = (e) => {
    updateForm({ ...formData, has_video_call: e });
  };

  const handleTimePerVisitChange = (e) => {
    updateForm({ ...formData, session_time: e });
  };

  const handleNumberInputChange = (e) => {
    const value = e.target.value;
    // Allow only numeric characters and handle backspace
    if (/^\d*$/.test(value)) {
      // Convert to integer and check range
      const intValue = parseInt(value, 10);
      if (value === "" || (intValue >= 1 && intValue <= 120)) {
        handleTimePerVisitChange(value);
      }
    }
  };

  const handleIsPrivateChange = () => {
    let is_private = isPrivate;
    updateForm({ ...formData, is_private: !is_private });
    setIsPrivate(!is_private);
  };

  const uniquePlaces = Array.from(
    new Set(departmentPlaces.map((item) => item.place.id))
  ).map((id) => departmentPlaces.find((item) => item.place.id === id)?.place);

  useEffect(() => {
    if (formData.place_id) {
      handlePlaceChange(formData.place_id);
    }
    if (formData.start) {
      handleStartTimeChange(formData.start.substring(0, 5));
    }
    if (formData.end) {
      handleEndTimeChange(formData.end.substring(0, 5));
    }
  }, []);

  useEffect(() => {
    if (formData.department_id && selectedPlace) {
      handleDepartmentChange(formData.department_id);
    }
  }, [selectedPlace]);

  useEffect(() => {
    if (selectedPlace) {
      const departments = departmentPlaces
        .filter((item) => item.place.id === parseInt(selectedPlace))
        .map((item) => item.department);
      setFilteredDepartments(departments);
    } else {
      setFilteredDepartments([]);
    }
  }, [selectedPlace, departmentPlaces]);

  useEffect(() => {
    setDepartmentPlaces(depPlace);
  }, [depPlace]);

  return (
    <div className="card w-100 background-bootstrap-gray-100">
      <div className="card-body p-2">
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-link color-bootstrap-regular-danger text-decoration-none p-1"
            onClick={() => removeForm(formId)}
          >
            <DeleteIcon width={24} height={24} className="me-1" />
            حذف
          </button>
        </div>

        {/* <div className="form-group">
          <label htmlFor={`shift-place-${formId}`}>مرکز درمانی</label>
          <input
            type="text"
            className="form-control"
            id={`shift-place-${formId}`}
            name="place_id"
            value={formData.place_id || ""}
            onChange={(e) => handlePlaceChange(parseInt(e.target.value))}
          />
        </div>

        <div className="form-group">
          <label htmlFor={`shift-department-${formId}`}>دپارتمان</label>
          <input
            type="text"
            className="form-control"
            id={`shift-department-${formId}`}
            name="department_id"
            value={formData.department_id || ""}
            onChange={(e) => handleDepartmentChange(parseInt(e.target.value))}
          />
        </div> */}

        <div>
          <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom">
            <div className="d-flex col col-auto px-0">
              <HomeHealthIcon width={24} height={24} />
            </div>
            <div className="d-flex col px-0">
              <div className="dropdown custom-dropdown w-100 ps-12px">
                <button
                  className="btn dropdown-toggle px-0 pt-0 pb-3 w-100 d-flex text-start border-0 rounded-0 align-items-center color-bootstrap-gray-600"
                  type="button"
                  id={`shift-place-${formId}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedPlace
                    ? uniquePlaces.find(
                      (place) => place.id === parseInt(selectedPlace)
                    ).title
                    : "مرکز درمانی"}
                  <ChevronDownIcon
                    className="arrow ms-auto"
                    width={24}
                    height={24}
                  />
                </button>
                <ul
                  className="dropdown-menu w-100"
                  aria-labelledby={`shift-place-${formId}`}
                >
                  {uniquePlaces.map((place, index) => (
                    <li key={index}>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => {
                          setSelectedDepartment(""); // Reset department selection
                          handlePlaceChange(place.id);
                        }}
                      >
                        {place.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 mt-2 border-bottom">
            <div className="d-flex col col-auto px-0">
              <DiversityIcon width={24} height={24} />
            </div>
            <div className="d-flex col px-0">
              <div className="dropdown custom-dropdown w-100 ps-12px">
                <button
                  className="btn dropdown-toggle px-0 pt-0 pb-3 w-100 d-flex text-start border-0 rounded-0 align-items-center color-bootstrap-gray-600"
                  type="button"
                  id={`shift-department-${formId}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  disabled={!selectedPlace}
                >
                  {selectedDepartment
                    ? filteredDepartments.find(
                      (department) =>
                        department.id === parseInt(selectedDepartment)
                    ).title
                    : "دپارتمان"}
                  <ChevronDownIcon
                    className="arrow ms-auto"
                    width={24}
                    height={24}
                  />
                </button>
                <ul
                  className="dropdown-menu w-100"
                  aria-labelledby={`shift-department-${formId}`}
                >
                  {filteredDepartments.map((department, index) => (
                    <li key={index}>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleDepartmentChange(department.id)}
                      >
                        {department.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Add other form fields as needed */}
        <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom mt-3 mb-1">
          <div className="d-flex col col-auto px-0">
            <ScheduleIcon width={24} height={24} />
          </div>
          <div className="d-flex col px-0">
            <div className="form-group w-100 ms-12px pb-3">
              <label className="mb-3" htmlFor={`shift-time-${formId}`}>
                ساعت کاری
              </label>
              <div
                className="d-flex row gx-2"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="d-flex col col-6">
                  <PersianTimePicker
                    label="ساعت شروع"
                    value={formData.start ? formData.start : null}
                    // name="start"
                    onChange={handleStartTimeChange}
                  />
                </div>
                <div className="d-flex col col-6">
                  <PersianTimePicker
                    label="ساعت پایان"
                    value={formData.end ? formData.end : null}
                    onChange={handleEndTimeChange}
                  />
                </div>
              </div>
              {/* <div className="input-group">
                <input
                  type="time"
                  aria-label="Start Time"
                  className="form-control"
                  placeholder="ساعت شروع"
                  id={`shift-time-start-${formId}`}
                  name="start"
                  value={formData.start || ""}
                  onChange={handleInputChange}
                />
                <input
                  type="time"
                  aria-label="End Time"
                  className="form-control"
                  placeholder="ساعت پایان"
                  id={`shift-time-end-${formId}`}
                  name="end"
                  value={formData.end || ""}
                  onChange={handleInputChange}
                />
              </div> */}
            </div>
          </div>
        </div>

        {/* type of visit */}
        <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom">
          <div className="d-flex col col-auto px-0">
            <StethoscopeIcon width={24} height={24} />
          </div>
          <div className="d-flex col px-0">
            <div className="d-flex row w-100 pb-3 mx-0 ms-2 gx-3 gy-2">
              <div className="d-flex col col-12 px-0 mb-12px justify-content-start">
                <span className="fs-16 fw-normal">نوع ویزیت</span>
              </div>
              <div className="d-flex col col-6 ps-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_in_person == true ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => {
                    let temp = formData.has_in_person
                      ? formData.has_in_person
                      : false;
                    handleInPersonTypeChange(!temp);
                  }}
                >
                  <LocationOnIcon width={20} height={20} className="me-2" />
                  <span>حضوری</span>
                </span>
              </div>
              <div className="d-flex col col-6 pe-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_voice_call == true ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => {
                    let temp = formData.has_voice_call
                      ? formData.has_voice_call
                      : false;
                    handleVoiceTypeChange(!temp);
                  }}
                >
                  <CallIcon width={20} height={20} className="me-2" />
                  <span>تلفنی</span>
                </span>
              </div>
              <div className="d-flex col col-6 ps-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_text == true ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => {
                    let temp = formData.has_text ? formData.has_text : false;
                    handleTextTypeChange(!temp);
                  }}
                >
                  <ChatIcon width={20} height={20} className="me-2" />
                  <span>متنی</span>
                </span>
              </div>
              <div className="d-flex col col-6 pe-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.has_video_call == true ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => {
                    let temp = formData.has_video_call
                      ? formData.has_video_call
                      : false;
                    handleVideoTypeChange(!temp);
                  }}
                >
                  <VideoIcon width={20} height={20} className="me-2" />
                  <span>ویدئویی</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* time per visit */}
        <div className="d-flex row form-check ps-0 mt-3 mx-0 color-bootstrap-gray-600 border-bottom">
          <div className="d-flex col col-auto px-0">
            <AvgPaceIcon width={24} height={24} />
          </div>
          <div className="d-flex col px-0">
            <div className="d-flex row w-100 pb-3 mx-0 ms-2 gx-3 gy-2">
              <div className="d-flex col col-12 px-0 mb-12px justify-content-start">
                <span className="fs-16 fw-normal">زمان هر ویزیت</span>
              </div>
              <div className="d-flex col col-4 ps-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.session_time == 5 && !customSession
                    ? " active"
                    : ""
                    }`}
                  type="button"
                  onClick={() => {
                    setCustomSession(false);
                    handleTimePerVisitChange(5);
                  }}
                >
                  <span>5 دقیقه</span>
                </span>
              </div>
              <div className="d-flex col col-4">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-2 fs-14 fw-normal w-100 justify-content-center align-items-center${formData.session_time == 10 && !customSession
                    ? " active"
                    : ""
                    }`}
                  type="button"
                  onClick={() => {
                    setCustomSession(false);
                    handleTimePerVisitChange(10);
                  }}
                >
                  <span>10 دقیقه</span>
                </span>
              </div>
              <div className="d-flex col col-4 pe-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-2 fs-14 fw-normal w-100 justify-content-center align-items-center${formData.session_time == 15 && !customSession
                    ? " active"
                    : ""
                    }`}
                  type="button"
                  onClick={() => {
                    setCustomSession(false);
                    handleTimePerVisitChange(15);
                  }}
                >
                  <span>15 دقیقه</span>
                </span>
              </div>

              <div className="d-flex col col-4 ps-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-12px fs-14 fw-normal w-100 justify-content-center align-items-center${formData.session_time == 20 && !customSession
                    ? " active"
                    : ""
                    }`}
                  type="button"
                  onClick={() => {
                    setCustomSession(false);
                    handleTimePerVisitChange(20);
                  }}
                >
                  <span>20 دقیقه</span>
                </span>
              </div>
              <div className="d-flex col col-4">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-2 fs-14 fw-normal w-100 justify-content-center align-items-center${formData.session_time == 30 && !customSession
                    ? " active"
                    : ""
                    }`}
                  type="button"
                  onClick={() => {
                    setCustomSession(false);
                    handleTimePerVisitChange(30);
                  }}
                >
                  <span>30 دقیقه</span>
                </span>
              </div>
              <div className="d-flex col col-4 pe-0">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-2  fs-14 fw-normal w-100 justify-content-center align-items-center${formData.session_time == 45 && !customSession
                    ? " active"
                    : ""
                    }`}
                  type="button"
                  onClick={() => {
                    setCustomSession(false);
                    handleTimePerVisitChange(45);
                  }}
                >
                  <span>45 دقیقه</span>
                </span>
              </div>
              <div className="d-flex col col-12 px-0 flex-column">
                <span
                  className={`d-flex btn-blue-check rounded-pill py-2px border border-1 px-2 fs-14 fw-normal w-100 justify-content-center align-items-center${customSession ? " active" : ""
                    }`}
                  type="button"
                  onClick={() => {
                    setCustomSession(true);
                    handleTimePerVisitChange(0);
                  }}
                >
                  <span>زمان دلخواه</span>
                </span>
                {customSession && (
                  <div className="input-group mt-2">
                    <input
                      type="text"
                      pattern="[0-9]*"
                      inputMode="numeric"
                      maxLength={3}
                      className="form-control"
                      placeholder="زمان بر حسب دقیقه"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      onChange={handleNumberInputChange}
                      value={formData.session_time || ""}
                    />
                    <span className="input-group-text" id="basic-addon2">
                      دقیقه
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex row form-check gap-2 ps-0 mt-3 mx-0 color-bootstrap-gray-600">

          <div className="tw-flex tw-items-center tw-justify-between">

            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="d-flex col col-auto px-0">
                <EnhancedEncryptionIcon width={24} height={24} />
              </div>
              <label className="fs-16 fw-normal" htmlFor="isPrivate">
                نوبت‌دهی خصوصی
              </label>
            </div>

            <div className="form-check form-switch d-flex align-items-center ms-auto">
              <input
                className="form-check-input m-0"
                type="checkbox"
                role="switch"
                id="isPrivate"
                checked={isPrivate}
                onChange={handleIsPrivateChange}
              />
            </div>

          </div>

          <span className="d-flex py-0 fs-14 fw-normal w-100 color-bootstrap-gray-700 align-items-center">
            درصورت فعال بودن ، فقط منشی و پزشک میتوانند نوبت‌دهی را انجام
            دهند
          </span>

        </div>

        <span className="tw-block tw-w-full tw-h-px tw-bg-[#CED4DA] tw-rounded-full tw-my-4"></span>

        <div className="d-flex row form-check gap-2 ps-0 mt-3 mx-0 color-bootstrap-gray-600">

          <div className="tw-flex tw-items-center tw-justify-between">

            <div className="tw-flex tw-gap-2 tw-items-center">
              <div className="d-flex col col-auto px-0 tw-size-6">
                <img src="./work_on_holiday.png" alt="work_on_holiday.png" />
              </div>
              <label className="fs-16 fw-normal" htmlFor="onHoliday">
                فعالیت در تعطیلات
              </label>
            </div>

            <div className="form-check form-switch d-flex align-items-center ms-auto">
              <input
                className="form-check-input m-0"
                type="checkbox"
                role="switch"
                id="onHoliday"
                checked={workOnHoliDay}
                onChange={() => {
                  setWorkOnHoliDay(prev => !prev)
                  updateForm({ ...formData, work_on_holidays: Number(Boolean(!workOnHoliDay)) })
                }}
              />
            </div>

          </div>

          <span className="d-flex py-0 fs-14 fw-normal w-100 color-bootstrap-gray-700 align-items-center">
            در ایام تعطیل رسمی (بین هفته) مایل به فعالیت هستم
          </span>

        </div>

      </div>
    </div>
  );
};

export default ShiftFormCard;
